import { Loader } from '@googlemaps/js-api-loader'

export const map = () => {

	let el = document.querySelector('[data-address]')

	if (!el) return

	const apiKey = 'AIzaSyBdens4oYOWrsnqPGyWssSf6VPHd78vEdU'

	let lat = parseFloat(el.dataset.lat),
		lng = parseFloat(el.dataset.lng),
		address = el.dataset.address

	const loader = new Loader({
		apiKey: apiKey,
		version: 'weekly',
	})

	let styles = [
		{
			featureType: "administrative",
			elementType: "geometry",
			stylers: [{ visibility: "off" }]
		},
		{
			featureType: "poi",
			stylers: [{ visibility: "off" }]
		},
		{
			featureType: "road",
			elementType: "labels.icon",
			stylers: [{ visibility: "off" }]
		},
		{
			featureType: "transit",
			stylers: [{ visibility: "off" }]
		},
		{
			featureType: "landscape.man_made",
			stylers: [{ visibility: "off" }]
		},
		{
			featureType: "poi.business",
			stylers: [{ visibility: "off" }]
		},
		{
			featureType: "landscape",
			elementType: "geometry",
			stylers: [{ color: "#F0EAE1" }]
		},
		{
			featureType: "road",
			elementType: "geometry",
			stylers: [{ color: "#ffffff" }]
		}
	];

	loader.load().then(() => {

		let map = new google.maps.Map(el, {
			center: { lat, lng },
			zoom: 18,
			styles: styles,
			mapTypeControl: false,
			streetViewControl: false,
			zoomControl: true,
			fullscreenControl: false
		})

		let icon = {
			url: "/dist/images/marker.svg",
			scaledSize: new google.maps.Size(75, 60),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(37.5, 60)
		};

		new google.maps.Marker({
			position: { lat, lng },
			map: map,
			title: address,
			icon: icon,
		})

	})
}

export default () => { }